import { useEffect, useState } from 'react';

import Spinner from 'react-bootstrap/Spinner'

import Menu from '../../components/MenuDuroc';
import constantes from '../../helpers/constanteHelper';
import CardEmpresaGenerico from '../../components/CardEmpresaGenerico';
import FiltrosEmpresasGenerico from '../../components/FiltrosEmpresasGenerico';
import TituloNegrito from '../../components/TituloNegrito';

import sheetsService from '../../services/sheetsServiceDuroc'

function CatalogoDurocEmpresas() {
    const [width, setWidth] = useState(window.innerWidth);
    const [empresasSemFiltro, setEmpresasSemFiltro] = useState([])
    const [empresas, setEmpresas] = useState();

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        sheetsService.buscarDadosEmpresas().then((empresasBuscadas) => {
            setEmpresas(empresasBuscadas)
            setEmpresasSemFiltro(empresasBuscadas)
        })
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    function aplicarFiltros(valor) {
        if (valor === '' || !valor) {
            setEmpresas(empresasSemFiltro)
        } else {
            setEmpresas(empresasSemFiltro.filter((empresa) => empresa['Empresa']?.toUpperCase().includes(valor.toUpperCase())))
        }
    }

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.DOURADO_DUROC }} className='d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'empresas'} />
                <TituloNegrito texto={'Filtros'} />

                <FiltrosEmpresasGenerico aplicarFiltros={aplicarFiltros} resolucaoMobile={resolucaoMobile} />

                <div style={{ width: '80vw', gap: '20px' }} className='my-5 d-flex flex-wrap align-items-center justify-content-center'>
                    {empresas ? empresas.length > 0 ? empresas.map((empresa) => <CardEmpresaGenerico key={empresa['Empresa']} empresa={empresa} pathCatalogo={'catalogo-duroc'} />)
                        : <div style={{ height: '40vh', gap: '20px' }} className='mt-2 mb-2 d-flex flex-column align-items-center justify-content-center text-center'>
                            <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>Página em construção. Em breve as informações estarão disponíveis.</span>
                        </div>
                        : <div style={{ width: '100vw', minHeight: '100vh', background: constantes.CORES.DOURADO_DUROC }} className='d-flex flex-column align-items-center'>
                            <div style={{ height: '50vh', gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center text-center'>
                                <Spinner style={{ height: '60px', width: '60px' }} variant='light' />
                                <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>Carregando dados...<br />Por gentileza, aguarde alguns instantes.</span>
                            </div>
                        </div>}
                </div>
            </div>
        </>
    );
}

export default CatalogoDurocEmpresas;
